module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"label":"查看 AI 推薦的尺寸"}}')
  delete Component.options._Ctor
}
